// Text constants for QuotesFallbackView component
const fallbackViewTexts = {
  cardTitle: 'Lock In Pricing.\nQuote with Confidence.',
  bodyText: 'Confirm availability, set delivery or pickup, and finalize pricing. '
  + 'Create quotes for one-time purchases or each project phase.',
  imageAlt: 'Placeholder image',
  learnMoreText: 'Learn More',
  imageUrl: 'https://dam.thdstatic.com/content/production/q7k5j90tEwVD1kPkixSQQQ/'
  + 'OkRd7qOTw_7UpErTtyrMew/Original%20file/WF-6260106-AccountQuotes-Hero.jpg',
};

export default fallbackViewTexts;
